import { createSlice } from "@reduxjs/toolkit";
import Axios from "axios";
import { BASE_API_URL } from "../../utils/constants";

const baseURL = BASE_API_URL;

export const BusinessPOCSlice = createSlice({
 name: "businessPOC",
 initialState: {
  error: false,
  trainingData: [],
  nominationData: [],
  enterpriseID: "",
  uploadedCourseList: [],
  individualCourseList: [],
  currentMonth: "",
  currentMonthIndex: "",
 },

 reducers: {
  setTrainingData: (state, { payload }) => {
   state.error = false;
   state.trainingData = payload;
  },
  setNominationData: (state, { payload }) => {
   state.error = false;
   state.nominationData = payload;
  },
  setEnterpriseID: (state, { payload }) => {
   state.enterpriseID = payload.name;
  },
  setUploadedCourseList: (state, { payload }) => {
   state.uploadedCourseList = payload;
  },
  setIndividualCourseList: (state, { payload }) => {
   state.individualCourseList = payload;
  },
  setCurrentMonth: (state, { payload }) => {
   state.currentMonth = payload;
  },
  setCurrentMonthIndex: (state, { payload }) => {
   state.currentMonthIndex = payload;
  },


  setError: (state) => {
   state.error = true;
  },
 },
});

// Action creators are generated for each case reducer function
export const {
 setTrainingData,
 setError,
 setNominationData,
 setUpdatedStatus,
 setEnterpriseID,
 setUploadedCourseList,
 setIndividualCourseList,
 setCurrentMonth,
 setCurrentMonthIndex,
} = BusinessPOCSlice.actions;

export default BusinessPOCSlice.reducer;

export function getTrainingListData(month, year) {
 return (dispatch) => {
  Axios.get(`${baseURL}/fetchTrainingList/${month}/${year}`, {
   headers: {
    Authorization: localStorage.getItem("token"),
    "Content-Type": "application/json",
   },
  })
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setTrainingData(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));
    console.error("error is", err);
   });
 };
}
export function updateLoginUserName(name) {
 return (dispatch) => {
  dispatch(setEnterpriseID({ name }));
 };
}

export function fetchPOCUploadedIndividualList(username,startDate,endDate) {
 return (dispatch) => {
  Axios.post(
   `${baseURL}/fetchpocUploadedindividualList`,
   { username,startDate,endDate },
   {
    headers: {
     Authorization: localStorage.getItem("token"),
     "Content-Type": "application/json",
    },
   }
  )
   .then((res) => {
    res.data.map((val, i) => {
     val.sno = i + 1;
    });
    dispatch(setIndividualCourseList(res.data));
   })
   .catch((err) => {
    dispatch(setError(err));

    console.error("error is", err);
   });
 };
}

export function getCurrentMonth() {
 return (dispatch) => {
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth() + 1;
  dispatch(setCurrentMonthIndex(currentMonthIndex));
 };
}
